import WorkerFunction from '@/utils/web-worker';
import { getBrowserInfo, isCooperationPage } from '@/utils/api';
import { getStorageAuthInfo } from '@/utils/storageOperateApi';
import { TRACK_MODULE_BRM } from './trackModuleBRM';
import { LOCAL_STORAGE_KEY } from '@/constants';
import { HOST } from '@/jmHttp/host';
import { PORTVERSION } from '@/jmHttp/host';
const isElectron = Boolean(window.process?.versions?.electron);

class Statistic {
  constructor() {
    const config = {
      b: '4.2.0800',
      baseUrl: HOST
    };
    this.header = {
      app: 'json',
      mod: 'statistic',
      act: 'click',
      os: isElectron ? 'pc-app' : 'brm',
      c: 'pc',
      uc: ''
    };
    this.worker = {};
    this.init(config);
    this.createContext();
    return this;
  }

  init(config) {
    if (Object.prototype.toString.call(config) !== '[object Object]') {
      throw new Error('参数config格式错误：' + config + '，期望格式为Object');
    }
    const { baseUrl, ...others } = config;
    if (!baseUrl) {
      throw new Error('参数config格式错误：' + config + '必须包含baseUrl');
    }
    this.baseUrl = baseUrl;
    this.header = { ...this.header, ...others };
  }

  createContext() {
    this.updateConfig = this.updateConfig.bind(this);
    this.statistic = this.statistic.bind(this);
    this.webSend = this.webSend.bind(this);
    this.getCommonArgs = this.getCommonArgs.bind(this);
  }

  updateConfig(data = {}) {
    this.header = {
      ...this.header,
      ...data
    };
  }

  statistic(data, config = {}) {
    if (Object.prototype.toString.call(data) !== '[object Object]') {
      throw new Error('参数data格式错误：' + data + '，期望格式为Object');
    }
    let { content } = data;
    const { statisticnum } = data;

    const num = this.getValueByPath(statisticnum);
    if (num === '' && statisticnum) {
      throw new Error('statisticNum尚未注册在STATISTIC_NUM');
    }

    // 判断是否是合作页面 在content 中加入标识
    const isCooperation = isCooperationPage();
    if (isCooperation) {
      if (content) {
        let contentObj;
        if (typeof content === 'object' && content !== null) {
          contentObj = content;
        } else {
          try {
            contentObj = JSON.parse(content);
          } catch (e) {
            contentObj = {
              key: content
            };
          }
        }
        content = JSON.stringify({
          ...contentObj,
          isCooperation
        });
      } else {
        content = JSON.stringify({
          isCooperation
        });
      }
    }
    data.statisticnum = num;
    return new Promise((resolve, reject) => {
      const { success, fail, error, ...others } = config;
      this.webSend(data, others, {
        success: success || resolve,
        fail: fail || error || reject
      });
    });
  }

  getValueByPath(path, obj = TRACK_MODULE_BRM) {
    // 如果存在-，如 "29-36-0"直接返回
    if (path === '') return path;
    if (path?.indexOf('-') !== -1) {
      return path;
    }
    const keys = path.split('.'); // 将路径字符串分割成键数组
    let current = obj;
    let result = '';

    // 遍历键数组来逐层深入到对象中
    for (const key of keys) {
      if (current[key] === undefined) {
        // 如果某个键不存在，则返回undefined
        return undefined;
      }
      current = current[key];
      if (current.value !== undefined) {
        // 如果当前级别有value，则将其添加到结果字符串中
        result += (result === '' ? '' : '-') + current.value;
      }
    }

    return result; // 返回构建的字符串
  }

  webSend(obj, config = {}, callback = {}) {
    const url = this.baseUrl;

    const param = {
      ...this.getCommonArgs(),
      ...this.header,
      ...obj
    };
    this.worker = WorkerFunction(this.fetch)(url, param, config);

    this.worker
      .then((result) => {
        if (result.errorcode === '0') {
          if (callback.success) {
            callback.success(result);
          }

          // 调试打印统计成功提示语
          // if (param.mod === 'statistic') {}
        } else {
          if (callback.fail) {
            callback.fail(result);
          }
        }
      })
      .catch((e) => {
        console.error(e.message, '埋点出错了~~~~');
        if (config.fail) {
          config.fail(e);
        }
      });
  }

  getCommonArgs() {
    const jmUserInfo = getStorageAuthInfo(LOCAL_STORAGE_KEY.JM_AUTH_INFO);
    return {
      platform: 'web',
      timestamp: Date.now(),
      ua: navigator.userAgent,
      uid: jmUserInfo?.uid || null,
      s: getBrowserInfo().name + '@' + getBrowserInfo().version
    };
  }

  fetch(url, param, config, done) {
    let xhr = null;
    let responseText = null;
    /* eslint-disable no-undef */
    if (XMLHttpRequest) {
      xhr = new XMLHttpRequest();
    } else if (ActiveXObject) {
      xhr = new ActiveXObject('Microsoft.XMLHTTP');
    }
    /* eslint-disable no-undef */

    // 接收请求状态变化
    xhr.onreadystatechange = function () {
      switch (xhr.readyState) {
        case 0:
          // console.log('新线程请求创建成功');
          break;
        case 1:
          // console.log('新线程请求开始发起');
          break;
        case 2:
          // console.log('新线程请求正在送往服务器');
          break;
        case 3:
          // console.log('新线程服务器已经在收集数据了');
          break;
        case 4:
          if ((xhr.status >= 200 && xhr.status < 300) || xhr.status === 304) {
            responseText = JSON.parse(xhr.responseText);
          } else {
            // console.log('Request was unsuccessful : ' + xhr.status + ' ' + xhr.statusText);
          }
          break;
        default:
        // console.log('不开心，服务器出错啦！');
      }
    };

    // xhr 选项配置
    const option = {
      isAsync: false,
      url: config.url || url,
      method: config.method || 'POST'
    };

    // 请求参数-头部固定参数
    const data = {};
    // 合并头部和自定义参数
    if (param)
      for (const v in param) {
        if (param.hasOwnProperty(v)) data[v] = param[v];
      }

    // 发起xhr请求
    if (option.method.toLowerCase() === 'post') {
      xhr.open(option.method, option.url, option.isAsync);
      xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded;charset=UTF-8');
      xhr.send(postDataFormat(data));
    } else if (option.method.toLowerCase() === 'get') {
      xhr.open(option.method, option.url + '?' + postDataFormat(data), option.isAsync);
      xhr.setRequestHeader('Content-Type', 'text/plain;charset=UTF-8');
      xhr.send();
    }

    // 格式化post 传递的数据
    function postDataFormat(obj) {
      const arr = [];
      for (const attr in obj) {
        if (obj.hasOwnProperty(attr)) arr.push(attr + '=' + obj[attr]);
      }
      return arr.join('&');
    }

    // 输出 responseText
    done(responseText);
  }
}

const ProxySingelObject = function () {
  let instance;
  return function (config) {
    if (!instance) {
      instance = new Statistic(config);
      return instance;
    }
    return instance;
  };
};

const config = {
  b: PORTVERSION,
  baseUrl: HOST
};

export default ProxySingelObject()(config).statistic;
